import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gfu-base-carousel-indicators" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_testimonials_slider_item = _resolveComponent("testimonials-slider-item")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { content: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_carousel, {
        class: _normalizeClass(['gfu-testimonial-slider gfu-testimonial-slider--wide'])
      }, {
        default: _withCtx(({ onAction, currentItem }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.testimonials, (item, index) => {
            return (_openBlock(), _createBlock(_component_testimonials_slider_item, _mergeProps({
              key: item.name
            }, { ref_for: true }, item, {
              class: ['gfu-base-carousel-slide', { 'is-active': index === currentItem }],
              onClick: onAction
            }), null, 16 /* FULL_PROPS */, ["class", "onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        indicators: _withCtx(({ onSetCurrentIndex, currentItem }) => [
          _createElementVNode("nav", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.testimonials, (item, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                href: "#",
                class: _normalizeClass(['gfu-base-carousel-indicators__indicator', {'is-active': index === currentItem}]),
                onClick: _withModifiers($event => (onSetCurrentIndex(index)), ["prevent"])
              }, _toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        nav: _withCtx(({ onNext, onPrev }) => [
          _createElementVNode("span", {
            class: "gfu-testimonial-slider-nav",
            onClick: onPrev
          }, null, 8 /* PROPS */, _hoisted_3),
          _createElementVNode("span", {
            class: "gfu-testimonial-slider-nav",
            onClick: onNext
          }, null, 8 /* PROPS */, _hoisted_4)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}